// Decouples api.js (used by every page, public and admin) from the Firebase
// Auth SDK (used only under /admin). AuthContext registers the real provider
// when it mounts; public pages never trigger that import, so they never pay
// for the Firebase Auth bundle.
let tokenProvider = null;

export const setAuthTokenProvider = (fn) => {
    tokenProvider = fn;
};

export const getAuthToken = () => (tokenProvider ? tokenProvider() : Promise.resolve(null));
